<template>
  <div>
    <!-- 搜索表单 -->
    <search-form :formConfig="formConfig" :source="searchData" @search="search" @handleSearch="handleSearch">
      <template slot="btns" v-if="formBtns.indexOf('exportBtn') > -1">
        <a-button @click="onExport" class="search-btn-item" type="primary">导出</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('importBtn') > -1">
        <a-button @click="onImport" class="search-btn-item" type="primary">导入发票</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('addContract') > -1">
        <a-button @click="addContract()" class="search-btn-item" type="primary"
          :disabled="selectedRowKeys.length == 0">匹配合同</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('delContract') > -1">
        <a-button @click="delContract()" class="search-btn-item" type="primary"
          :disabled="selectedRowKeys.length == 0">解除合同</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('addvoucher') > -1">
        <a-button @click="toDeliveryCreate('add')" class="search-btn-item" type="primary"
          :disabled="selectedRowKeys.length == 0">匹配凭证</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('revokeBtn') > -1">
        <a-button @click="cancel('撤销')" class="search-btn-item btn-red-line"
          :disabled="selectedRowKeys.length == 0">撤销</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('applyBtn') > -1">
        <a-button class="search-btn-item" type="primary" :disabled="selectedRowKeys.length == 0"
          @click="systemCheck">平台查验</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('applyUserBtn') > -1">
        <a-button class="search-btn-item" type="primary" :disabled="selectedRowKeys.length == 0"
          @click="selfCheck">自助查验</a-button>
      </template>
      <template slot="btns" v-if="formBtns.indexOf('deletBtn') > -1">
        <a-button @click="cancel('删除')" class="search-btn-item btn-red-line"
          :disabled="selectedRowKeys.length == 0">删除</a-button>
        <span class="text-color-orange"
          v-if="selectedRowKeys.length > 0 && formBtns.indexOf('applyBtn') > -1">温馨提示：若信息无误，自助查验仍不通过，可申请平台平台查验</span>
      </template>
    </search-form>

    <!-- 祺信开立 -->
    <div v-if="formBtns.indexOf('openGold') > -1" style="padding:15px 0 0 10px; background:#fff;margin-bottom:15px;">
      <!-- <a-form-model ref="goldOpenForm" :model="goldOpenForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }"
        labelAlign="right">
        <div class="spaceLeft">
          <div>
            <a-form-model-item label="到期日：" prop="exDat" :rules="[
              { required: true, whitespace: true, message: '请选择到期日' }
            ]">
              <a-date-picker :disabled-date="disabledDate" valueFormat="YYYY-MM-DD" v-model="goldOpenForm.exDat"
                placeholder="请选择" />
            </a-form-model-item>
          </div>
          <div style="margin-right:16px;">
            <a-form-model-item label="可否变更：" prop="canBeModified" :rules="[
              {
                required: true,
                whitespace: true,
                validator: canBeModifiedCheck
              }
            ]">
              <div class="spaceLeft" style="flex-wrap: nowrap;">
                <a-popover title="可否变更：">
                  <template slot="content">
                    <p>
                      若选择是，开立方在收到付款通知前，可向前变更祺信到期日期，且仅可变更一次。
                    </p>
                    <p>若选择否，祺信到期日期将不可变更。</p>
                  </template>
                  <a-icon type="question-circle" class="common-question" />
                </a-popover>
                <div style="width:200px">
                  <a-select v-model="goldOpenForm.canBeModified" :allowClear="true" option-label-prop="label"
                    style="width:100%">
                    <a-select-option v-for="item in canBeModifiedList" :key="item.value" :value="item.value"
                      :label="item.name">{{ item.name }}</a-select-option>
                  </a-select>
                </div>
              </div>
            </a-form-model-item>
          </div>
          <div>
            <a-form-model-item label="罚息利率：" prop="overdueRate " style="width:220px" :rules="[
              {
                required: true,
                whitespace: true,
                validator: overdueRateCheck
              }
            ]">
              <div class="spaceLeft" style="flex-wrap: nowrap;width:400px">
                <a-popover title="罚息利率：">
                  <template slot="content">
                    <p style="width:300px">
                      若勾选1年期LRP，系统将自动转化为日利率。（日利率=年利率/360，日利率保留四位小数，第四位小数加1）
                    </p>
                  </template>
                  <a-icon type="question-circle" class="common-question" />
                </a-popover>
                <div style="width:200px">
                  <a-input :disabled="isLRP" v-model="goldOpenForm.overdueRate" placeholder="请输入" suffix="日利率(%)" />
                </div>
                <a-checkbox v-model="isLRP" style="margin-left:10px;" v-if="LRP">1年期LPR({{ LRP }}%)</a-checkbox>
              </div>
            </a-form-model-item>
          </div>
        </div>
      </a-form-model> -->

      <a-button @click="onOpen" :disabled="openDisabled" class="search-btn-item btn-blue-line"
        style="margin-bottom:15px;">开立祺信</a-button>
      <a-button type="primary" @click="onOtherOpen">其他开立</a-button>
      <a-button type="primary" @click="onOtherOpenlists">批量开票</a-button>
    </div>

    <!-- 表格 -->
    <div class="table-common common common-scroll">
      <div class="table-check-bar" v-if="selectedRows.length">
        已选择：
        <span class="text-color-blue">{{ selectedRows.length }} 条</span>
        <span>
          {{ selectName }}：
          <span class="text-color-orange">
            {{ totalPayable(selectedRows) | splitK }} 元
          </span>
        </span>

        <template v-if="exDateCounts">
          <span>距到期日还有 <span class="text-color-orange">{{ exDateCounts }} 天</span></span>
        </template>

      </div>
      <a-table size="middle" :columns="columns" :row-key="record => record.id" :data-source="tableData"
        :pagination="pagination" :loading="loading" @change="handleTableChange" bordered :locale="{ emptyText: '暂无数据' }"
        :row-selection="tableSelect" :scroll="{}">
        <template slot="cyCode" slot-scope="text, record">
          <div class="spceCenter">
            <div class="ellipsis" style="flex:1;" :title="text">
              {{ text }}
            </div>
            <a-popover :title="'不通过原因-' +
              (record.checkType == 'auto' ? '自助查验' : '平台查验')
              ">
              <template slot="content">
                <div style="color:#666;max-width:200px;">
                  {{ record.resultMsg || "暂无原因" }}
                </div>
              </template>
              <svg v-if="record.resultCode == 2" class="payable-icon" aria-hidden="true">
                <use xlink:href="#gold-icon-tishi"></use>
              </svg>
            </a-popover>
          </div>
        </template>
        <template slot="payableAmount" slot-scope="text,record">
          <a-input v-model="record.gldAmt" @blur="gldAmtCheck(record)" class="text-center" />
          <div v-if="!record.gldAmtCheck" class="text-color-orange text-center">
            输入金额不能大于{{ record.canEstbGldBal | splitK }}元
          </div>
        </template>
        <template slot="rcvbBal" slot-scope="text">
          {{ text | splitK }}
        </template>
        <template slot="canEstbGldBal" slot-scope="text">
          {{ text | splitK }}
        </template>
        <template slot="billTime" slot-scope="text">
          {{ text | dateFormat("YYYY-mm-dd") }}
        </template>
        <template slot="invoiceType" slot-scope="text">
          {{ text | invoiceTypeFilter }}
        </template>
        <template slot="invoiceCode" slot-scope="text, record">
          <span v-if="record.invoiceCode">{{ record.invoiceCode }}</span>
          <span v-if="!record.invoiceCode">--</span>
        </template>
        <template slot="invoiceNumber" slot-scope="text, record">
          <a @click="toInvoiceInfo(record)">{{ text }}</a>
        </template>

        <template slot="invoiceAmountWithVat" slot-scope="text">
          {{ text | splitK }}
        </template>
        <template slot="checkType" slot-scope="text">
          {{ text | checkTypeFilter }}
        </template>
        <template slot="contract" slot-scope="text, record">
          <a v-if="text" @click="contractInfoOpen(record)">{{ text }}</a>
          <span v-else>--</span>
        </template>
        <template slot="voucherCodes" slot-scope="text, record">
          <span :title="text">
            <a v-if="text" @click="toDeliveryCreate('detail', record)">
              {{ text }}
            </a>
            <span v-else>--</span>
          </span>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a v-if="voucherCodesOper('add', record)" @click="toDeliveryCreate('add', record)">上传</a>
          <a v-if="voucherCodesOper('edit', record)" @click="toDeliveryCreate('edit', record)">编辑</a>
          <a v-if="voucherCodesOper('detail', record)" @click="toDeliveryCreate('detail', record)">查看</a>
        </template>
        <template slot="operationEdit" slot-scope="text, record">
          <a @click="toInvoiceInfo(record)">查看</a>
          <a @click="toInvoiceEdit(record)">编辑</a>
        </template>
        <template slot="openGold" slot-scope="text, record">
          {{ record.gldAmt | splitK }}
          <!-- <a-input
            v-model="record.gldAmt"
            @blur="gldAmtCheck(record)"
            class="text-center"
          />
          <div v-if="!record.gldAmtCheck" class="text-color-orange text-center">
            输入金额不能大于{{ record.canEstbGldBal | splitK }}元
          </div> -->
        </template>
        <template slot="openedAmount" slot-scope="text, record">
          {{ openedAmount(record, canEstbGldBal) }}
        </template>
      </a-table>
      <div :class="{
        'table-total': pagination.total > 0,
        'table-total-none': pagination.total == 0
      }">
        共有记录：
        <span class="text-color-blue"> {{ pagination.total }} 条 </span>
        {{ totalName }}：
        <span class="text-color-orange">
          {{ totalPayable(tableData) | splitK }} 元
        </span>
        可开立余额(元)：
        <span class="text-color-orange">
          {{ totalPayable(tableData, 'canEstbGldBal') | splitK }} 元
        </span>

      </div>
    </div>
    <!-- 查看弹窗 -->
    <invoiceInfo ref="invoiceInfo" :readonly="true" :info.sync="curRow" />
    <!-- 编辑弹窗 -->
    <invoiceInfo ref="invoiceEdit" :readonly="false" :info.sync="curRow" :btns="['save', 'close']" @save="successHandle"
      @check="successHandle" />
    <!-- 匹配合同 -->
    <contractDialog title="匹配合同" ref="contractEdit" :readonly="false" :selectedRows.sync="selectedRows"
      :btns="['save', 'close']" @save="contractSuccessHandle" />
    <!-- 查看合同 -->
    <contractDialog title="匹配合同详情" ref="contractInfo" :readonly="true" :info.sync="curRow" />
    <!-- 导入弹窗 -->
    <a-modal title="导入" v-model="modalShowImport" @ok="checkSeller" @cancel="closeImport" width="450px"
      :loading="importDialogLoad" destroyOnClose>
      <a-form-model ref="ruleFormImport" :model="importData" :label-col="{ span: 8 }" :wrapper-col="{ span: 13 }">
        <a-form-model-item label=" " prop="importType" :colon="false" style="margin-bottom:8px;">
          <a-radio-group name="importType" v-model="importData.importType">
            <a-radio v-for="item in importType" :value="item.value" :key="item.value">
              {{ item.name }}
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="卖方名称" prop="importType" style="margin-bottom:8px;">
          <!-- <a-input v-show="importData.importType == 2" v-model="importData.tenantName2" placeholder="请输入" /> -->
          <select-search v-show="importData.importType == 2" v-model="importData.tenantObj2" :searchSource="true"
            :dataSource="importTypeOption" headNameFirst="卖方名称" headNameSecond="社会信用代码" valuePorp="orgCode"
            labelPorp="userName" @handleChange="changeTenant" @handleSearch="handleSearchType"></select-search>
          <select-search v-show="importData.importType == 1" v-model="importData.tenantObj" :searchSource="true"
            :dataSource="importOption" headNameFirst="卖方名称" headNameSecond="社会信用代码" valuePorp="cstOrgCode"
            labelPorp="cstNm" @handleChange="changeTenant" @handleSearch="handleSearchImport"></select-search>
        </a-form-model-item>
        <a-form-model-item label="卖方社会信用代码" prop="importType" v-show="importData.importType == 1"
          style="margin-bottom:8px;">
          <a-input v-model="importData.tenantObj.key" disabled />
        </a-form-model-item>
        <a-form-model-item label=" " :colon="false" v-if="importData.importType == 2">
          <span class="text-color-red">{{ importErrText }}</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 开立确认 -->
    <confirmModal ref="modalGoldOpen" :confirmTableData.sync="confirmTableData" @ok="modalOk"
      :overdueRate.sync="otherform.overdueRate"></confirmModal>

    <a-modal width="420px" title="祺信开立" :visible="modalShowPwd" :maskClosable="false" :footer="null"
      @cancel="modalCancel">
      <confirmPasswordModal v-if="confirmModalData" :confirmData.sync="confirmTableData"
        :confirmModalData.sync="confirmModalData" :overdueRate.sync="otherform.overdueRate" @ok="modalOkPwd"
        @cancel="modalCancel"></confirmPasswordModal>
    </a-modal>
    <!--  其他开立  -->
    <a-spin :spinning="loading">
      <a-modal v-model:open="otherOpen" :confirm-loading="confirmLoading" on-ok="handleOk" width="900px"
        @cancel="handleotherCancel">
        <template slot="title">
          <div v-if="title == '其他开立'">
            <div>{{ title }}</div>
            <div style="font-size:12px;color:#B3B3B3;margin-top: 5px;">
              通过无发票开立的祺信，无法进行融资
            </div>
          </div>
          <div v-else>{{ title }} </div>
        </template>
        <a-form-model ref="rulesotherform" :model="otherform" :rules="rules" :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }">
          <div style="display:flex;justify-content: space-between;">
            <a-form-model-item style="width:320px" label="开立方" prop="estbName">
              <a-input style="width: 210px;" :disabled="true" v-model="otherform.estbName" />
            </a-form-model-item>
            <a-form-model-item style="width:245px" label="" prop="">
              <a-button primary @click="handlehistoryInfo">引入历史开票信息</a-button>
            </a-form-model-item>
          </div>
          <a-form-model-item prop="importType" :colon="false" style="margin-bottom:8px;margin-left:128px;width:320px">
            <a-radio-group name="importType" v-model="importData.importType">
              <a-radio v-for="item in importType" :value="item.value" :key="item.value" @click="hadleRadio(item.value)">
                {{ item.name }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <div style="display:flex;justify-content: space-between;" v-if="importData.importType == 1">
            <a-form-model-item style="width:320px" label="接收方" prop="rcPtyName">
              <select-search style="width: 210px;" v-model="importData.tenantObj" :searchSource="true"
                :dataSource="importOption" :other="true" headNameFirst="接收方名称" headNameSecond="社会信用代码"
                valuePorp="cstOrgCode" labelPorp="cstNm" @handleChange="changeTenant"
                @handleSearch="handleSearchImport"></select-search>
            </a-form-model-item>
            <a-form-model-item style="width:465px" label="社会信用代码" prop="cstOrgCode">
              <a-input style="width: 210px;" v-model="otherform.cstOrgCode" disabled />
            </a-form-model-item>
          </div>
          <div style="display:flex;justify-content: space-between;" v-if="importData.importType == 2">
            <div>
              <a-form-model-item style="width:320px;" label="接收方" prop="tenantName2">
                <!-- <a-input style="width: 210px;" v-model="otherform.tenantName2" @blur="handleBlur" placeholder="请输入" /> -->
                <select-search style="width: 210px;" v-model="importData2.tenantObj" :searchSource="true"
                  :dataSource="importOption" :other="true" headNameFirst="接收方名称" headNameSecond="社会信用代码"
                  valuePorp="orgCode" labelPorp="userName" @handleChange="changeTenantJR"
                  @handleSearch="handleBlur"></select-search>
              </a-form-model-item>
              <a-form-model-item label="" style="margin-bottom:8px;margin-left:108px;width:250px;white-space: nowrap;"
                :colon="false" v-if="importErrText">
                <span class="text-color-red">{{ importErrText }}</span>
              </a-form-model-item>
            </div>
            <a-form-model-item style="width:465px" label="社会信用代码" prop="OrgCode">
              <a-input style="width: 210px;" v-model="otherform.OrgCode" disabled />
            </a-form-model-item>
          </div>
          <div style="display:flex;justify-content: space-between;">
            <a-form-model-item style="width:255px" label="开立金额" prop="gldAmt">
              <div class="spaceLeft" style="flex-wrap: nowrap;width:400px">
                <a-popover title="开立金额">
                  <template slot="content">
                    <p style="width:300px">
                      开立金额只能输入数字和小数点，整数不分最多支持10位，小数点后支持2位
                    </p>
                  </template>
                  <a-icon type="question-circle" class="common-question" />
                </a-popover>
                <div style="display: flex; align-items: center;">
                  <a-input-number style="width: 210px;" v-model="otherform.gldAmt" placeholder="请输入" :min="0"
                    :max="9999999999.99" :precision="2" />
                  <!-- <a-input />元 -->
                </div>
              </div>
            </a-form-model-item>

            <a-form-model-item style="width:465px" label="兑付日期" prop="exDay">
              <a-date-picker style="width: 210px;" valueFormat="YYYY-MM-DD" v-model="otherform.exDay" placeholder="请选择"
                :disabled-date="disabledDate1" />
            </a-form-model-item>
          </div>
          <div style="display:flex;justify-content: space-between;">
            <a-form-model-item style="width:320px" label="是否可变更" prop="canBeModified">
              <a-select v-model="otherform.canBeModified" :allowClear="true" option-label-prop="label"
                style="width:210px">
                <a-select-option v-for="item in canBeModifiedList" :key="item.value" :value="item.value"
                  :label="item.name">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="罚息利率：" prop="overdueRate " style="width:500px" :rules="[
              {
                required: true,
                whitespace: true,
                validator: overdueRateCheck1
              }
            ]">
              <div class="spaceLeft" style="flex-wrap: nowrap;width:400px">
                <a-popover title="罚息利率：">
                  <template slot="content">
                    <p style="width:300px">
                      若勾选1年期LRP，系统将自动转化为日利率。（日利率=年利率/360，日利率保留四位小数，第四位小数加1）
                    </p>
                  </template>
                  <a-icon type="question-circle" class="common-question" />
                </a-popover>
                <div style="width:150px">
                  <a-input :disabled="isLRP1" v-model="otherform.overdueRate" placeholder="请输入" suffix="日利率(%)" />
                </div>
                <a-checkbox v-model="isLRP1" style="margin-left:10px;" v-if="LRP">1年期LPR({{ LRP }}%)</a-checkbox>
              </div>
            </a-form-model-item>
          </div>
          <div v-if="title == '其他开立'">
            <otherFileUpload ref="childFileUpload" :tblBlId='tblBlId' :introducedSource='introducedSource'
              @receiveFileTblBlId="receiveFileTblBlId"></otherFileUpload>
          </div>
        </a-form-model>
        <!-- <a-table :pagination="pagination" :columns="othercolumns" :data-source="otherdata" bordered
          :locale="{ emptyText: '暂无数据' }">
          <template slot="fileName" slot-scope="text, record">
            <a>{{ text }}</a>
          </template>
          <template slot="status" slot-scope="text, record">
            <div>{{ text }}</div>
          </template>
          <template slot="action" slot-scope="text, record">
            <div>
              <a-button type="link" @click="handleSort(record, 'up')">上移</a-button>
              <a-button type="link" @click="handleSort(record, 'down')">下移</a-button>
              <a-button type="link">删除</a-button>
            </div>
          </template>
        </a-table> -->
        <div style="display: flex;">
          <a-checkbox v-model="isOthercheck" style="margin:0 5px 16px 15px;"></a-checkbox>
          <div>已阅读并同意所勾选的<a @click="openFile">《付款承诺函》</a></div>
        </div>
        <template slot="footer">
          <a-button @click="handleotherCancel">
            关闭
          </a-button>
          <a-button type="primary" :loading="loading" @click="handleOk">
            确定
          </a-button>
        </template>
      </a-modal>
      <a-modal v-model:open="otherOpenTxnpwd" title="其他开立" width="420px" on-ok="handleOther">
        <a-spin :spinning="modalLoad">
          <div class="spaceCenter">
            <div>
              <div class="spaceLeft item-box">
                <label>祺信笔数：</label>
                <span class="text-color-blue" style="margin-right:5px;">1
                </span>
                笔
              </div>
              <div class="spaceLeft item-box">
                <label>祺信面额：</label>
                <span class="text-color-gold" style="margin-right:5px;">{{ otherform.gldAmt }}
                </span>
                元
              </div>
              <div class="spaceLeft item-box" style="">
                <label>交易密码：</label>
                <a-input type="password" v-model="txnPwd" class="item-input" />
              </div>
            </div>
          </div>
        </a-spin>
        <template slot="footer">
          <a-button @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" :loading="loading" @click="handleOther">
            确定
          </a-button>
        </template>
      </a-modal>
      <fileView :artcCntnt.sync="artcCntnt" ref="fileView" />
    </a-spin>
    <!-- 相关凭证 -->
    <deliveryVoucherDialog ref="deliveryVoucherDialog" :details='deliveryVoucherDialogState' @save="refresh()" />
    <batchInvoicingDialog ref="batchInvoicingDialog" :isShow="selectedRows">
    </batchInvoicingDialog>
    <historyInfo ref="historyInfo" @select-history="handleSelectHistory"></historyInfo>

  </div>
</template>

<script>
/**
 * 应付单据页面、祺信开立tab 均用此组件
 */
import invoiceInfo from "./invoice-info-dialog";
import contractDialog from "./contract-info-dialog";
import { selectSellerCst } from "@/api/rcvbBuy.js";
import {
  invoiceList,
  invDelete,
  go2Check,
  go2PlatFormCheck,
  selectSellerCstByName,
  deleteContractInfo,
  getparamValue,
  updateVoucherSort,
  queryInvoiceExport
} from "@/api/payable.js";
import { applyGoldApi, getParamByKey, verifyTradePassword, getLetterofCommitment, getparamkey } from "@/api/gold.js";
import { mapActions, mapGetters } from "vuex";
import confirmModal from "@/components/table-find-rcvb/confirm-modal";
import confirmPasswordModal from "@/components/table-find-rcvb/confirm-password-modal";
import fileView from "@/components/table-find-rcvb/fileView"
import { circleQuery } from "@/api/circle.js";
import deliveryVoucherDialog from "@/pages/bill-manage/payable/delivery-voucher-dialog";
import { queryByDate } from "@/api/center.js";
import moment from 'moment';
import { doSaveGuaranteeV2 } from "@/api/guarantee.js";
import otherFileUpload from './other-file-upload'
import batchInvoicingDialog from "./batchInvoicing";
import historyInfo from "./historyInfo.vue";
import { fileDeletAPI, fileSaveAPI, fileQueryAPI } from "@/api/file.js";
export default {
  props: {
    columnsSource: {
      type: [Array],
      required: false,
      default: function () {
        return null;
      }
    },
    formSource: {
      type: [Array],
      required: false,
      default: function () {
        return null;
      }
    },
    formBtns: {
      type: Array,
      default: function () {
        return [];
      }
    },
    resultCode: {
      type: [String, Number],
      required: false,
      default: function () {
        return 0;
      }
    },
    formType: {
      type: [String],
      required: false,
      default: function () {
        return "payable";
      }
    },
    tabType: {
      //属于哪个页面的tab下
      type: [String],
      required: false,
      default: function () {
        return "";
      }
    },
    totalName: {
      type: [String],
      required: false,
      default: function () {
        return "单据金额";
      }
    },
    selectName: {
      type: [String],
      required: false,
      default: function () {
        return "单据金额";
      }
    },
    canEstbGldBal: {
      type: [String],
      required: false,
      default: function () {
        return "";
      }
    },
    isHaveContractNo: {
      //是否匹配合同 1、0
      type: [String, Number],
      required: false,
      default: function () {
        return "";
      }
    }
  },
  components: {
    otherFileUpload,
    invoiceInfo,
    contractDialog,
    confirmModal,
    confirmPasswordModal,
    deliveryVoucherDialog,
    fileView,
    batchInvoicingDialog,
    historyInfo
  },
  name: "payableComponent",
  data() {
    const validateEndDate = (rule, value, callback) => {
      const date = new Date(); // 当前时间
      const isoString = date.toISOString(); // "2025-05-15T00:00:00.000Z"
      const formattedDate = isoString.split('T')[0]; // "2025-05-15"
      if (Date.parse(this.otherform.exDay) < Date.parse(formattedDate)) {
        this.importErrText = '兑付日期需大于当前日期'
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        callback();
      }
    };
    return {
      deliveryVoucherDialogState: false,
      paramValue: null,
      searchData: {
        sellrOrgCode: {},
        invoiceType: [],
        invoiceCode: undefined,
        invoiceNumber: undefined,
        cyCode: undefined,
        billTime: [],
        checkType: [],
        contractNo: undefined,
        voucherCode: undefined
      },
      introducedSource: [],
      formConfig: [
        {
          prop: "sellrOrgCode",
          type: "selectSearch",
          label: "卖方名称",
          option: [],
          searchSource: true,
          headNameFirst: "卖方名称",
          headNameSecond: "社会信用代码",
          valuePorp: "orgCode",
          labelPorp: "userName",
          searchHandle: "handleSearch"
        },
        {
          prop: "cyCode",
          type: "input",
          label: "查验编号"
        },
        {
          prop: "invoiceType",
          type: "select",
          label: "发票类型",
          mode: 'multiple',
          option: this.dict.invType,
          defaultProps: {
            value: "value",
            label: "name"
          }
        },
        {
          prop: "invoiceCode",
          type: "input",
          label: "发票代码"
        },
        {
          prop: "invoiceNumber",
          type: "input",
          label: "发票号码"
        },
        {
          prop: "contractNo",
          type: "input",
          label: "合同编号"
        },
        {
          prop: "billTime",
          type: "dateRange",
          label: "开票日期"
        },
        {
          prop: "checkType",
          type: "select",
          label: "查验方式",
          mode: 'multiple',
          option: [],
          defaultProps: {
            value: "dctVal",
            label: "dctValNm"
          }
        },
        {
          prop: "voucherCode",
          type: "input",
          label: "相关凭证"
        }
      ],
      columns: [
        {
          title: "查验编号",
          dataIndex: "cyCode",
          sorter: true,
          width: 180,
          scopedSlots: { customRender: "cyCode" }
        },
        {
          title: "卖方名称",
          dataIndex: "sellrName",
          width: 140,
          ellipsis: true,
          sorter: true
        },
        {
          title: "发票类型",
          dataIndex: "invoiceType",
          scopedSlots: { customRender: "invoiceType" },
          width: 90
        },
        {
          title: "发票代码",
          dataIndex: "invoiceCode",
          scopedSlots: { customRender: "invoiceCode" },
          width: 90
        },
        {
          title: "发票号码",
          sorter: true,
          dataIndex: "invoiceNumber",
          scopedSlots: { customRender: "invoiceNumber" },
          width: 120
        },
        {
          title: "开票日期",
          sorter: true,
          dataIndex: "billTime",
          scopedSlots: { customRender: "billTime" },
          width: 120
        },
        {
          title: "含税金额(元)",
          sorter: true,
          dataIndex: "invoiceAmountWithVat",
          scopedSlots: { customRender: "invoiceAmountWithVat" },
          width: 120
        },
        {
          title: "应付金额(元)",
          dataIndex: "payableAmount",
          scopedSlots: { customRender: "payableAmount" },
          sorter: true,
          width: 140
        },
        {
          title: "发票金额（元）",
          dataIndex: "invoiceAmountWithVat",
          scopedSlots: { customRender: "invoiceAmountWithVat" },
          sorter: true,
          width: 120
        },
        {
          title: "已开金额（元）",
          dataIndex: "openedAmount",
          scopedSlots: { customRender: "openedAmount" },
          width: 120
        },
        {
          title: "可开立余额(元)",
          dataIndex: "canEstbGldBal",
          scopedSlots: { customRender: "canEstbGldBal" },
          sorter: true,
          width: 120
        },

        {
          title: "查验方式",
          dataIndex: "checkType",
          scopedSlots: { customRender: "checkType" },
          width: 100
        },
        {
          title: "合同编号",
          dataIndex: "contractNo",
          scopedSlots: { customRender: "contract" },
          sorter: true,
          width: 180
        },
        {
          title: "相关凭证",
          dataIndex: "voucherCodes",
          ellipsis: true,
          width: 180,
          scopedSlots: { customRender: "voucherCodes" }
        },
        {
          title: "操作履约",
          title2: "操作",
          width: 100,
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" }
        },
        {
          title: "操作单据",
          title2: "操作",
          width: 100,
          dataIndex: "operationEdit",
          scopedSlots: { customRender: "operationEdit" }
        },
        {
          title: "祺信金额",
          dataIndex: "openGold",
          width: 100,
          scopedSlots: { customRender: "openGold" }
        }
      ],
      tableData: [],
      isInput: true,
      pagination: {
        pageSize: 10,
        current: 1,
        sortField: "cyCode",
        sortOrder: "descend",
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
        showTotal: total => {
          return `共 ${total} 条`;
        }
      },
      loading: false,
      selectedRows: [],
      selectedRowKeys: [],
      //  导入弹窗
      importData: {
        importType: "1",
        tenantName2: undefined, //键入值
        tenantObj: {
          cstNm: '',
          cstOrgCode: '',
          guaranteeCstId: '',
        },
        tenantObj2: {
          cstNm: '',
          cstOrgCode: '',
          guaranteeCstId: '',
        }
      },
      importData2: {
        importType: "2",
        tenantName2: undefined, //键入值
        tenantObj: {}
      },
      modalShowImport: false,
      importType: [
        { name: "圈子", value: "1" },
        { name: "键入", value: "2" }
      ],
      importTypeOption: [],
      importOption: [],
      importDialogLoad: false,
      importErrText: "",
      curRow: {}, //查看、编辑当前row
      // 祺信开立-开始
      holDayMap: {}, //存放节假日日期，按年份分组
      canBeModifiedList: [
        { name: "是", value: '1' },
        { name: "否", value: '0' }
      ],
      modalShowPwd: false,
      confirmModalData: null,
      confirmTableData: null,
      isLRP: false,
      LRP: 0.01,
      goldOpenForm: {
        overdueRate: undefined,
        exDat: "",
        canBeModified: undefined
      },
      isLRP1: false,
      txnPwd: '',
      otherOpen: false,
      otherOpenTxnpwd: false,
      confirmLoading: false,
      isOthercheck: false,
      modalLoad: false,
      artcCntnt: '',
      otherform: {
        estbName: undefined,
        importType: undefined,
        rcPtyName: undefined,
        cstOrgCode: undefined,
        tenantName2: undefined,
        OrgCode: undefined,
        gldAmt: undefined,
        exDay: undefined,
        canBeModified: undefined,
        overdueRate: undefined,
      },
      rules: {
        estbName: [
          { required: true, message: '请填写开立方企业名称', trigger: 'blur' },
        ],
        rcPtyName: [{ required: true, message: '请选择接收方企业名称', trigger: 'blur' }],
        gldAmt: [{ required: true, message: '请填写开立金额', trigger: 'blur' }],

        canBeModified: [
          { required: true, message: '请选择是否变更', trigger: 'blur' },
        ],
        // cstOrgCode: [{ required: true, message: '请填写社会信用代码', }],
        // OrgCode: [{ required: true, message: '请填写社会信用代码', }],
        // tenantName2: [{ required: true, message: '请填写接收方企业名称', trigger: 'blur' }],
        exDay: [{ required: true, message: '请填写兑付日期', trigger: 'blur' }, { validator: validateEndDate, trigger: 'change' },],
      },
      // 祺信开立-结束
      //其他开立表格
      othercolumns: [
        {
          title: '文件名称',
          dataIndex: 'fileName',
          ellipsis: true,
          key: 'fileName',
          scopedSlots: { customRender: 'fileName' }
        },
        {
          title: '上传结果',
          dataIndex: 'status',
          ellipsis: true,
          key: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          ellipsis: true,
          key: 'action',
          scopedSlots: { customRender: 'action' }
        },
      ],
      otherdata: [
      ],
      tblBlId: "",
      title: '',
      nextInvoice: false
    };

  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"
    }),

    openedAmount() {
      return (record) => {
        const amount = record.invoiceAmountWithVat - record.canEstbGldBal;
        return amount > 0 ? amount.toFixed(2) : '0.00';
      }
    },
    tableSelect() {
      return {
        type: "radio",
        selectedRowKeys: this.selectedRowKeys,
        selectedRows: this.selectedRows,
        // onSelectAll: this.onSelectAll,
        onSelect: this.onSelect,
        getCheckboxProps: record => ({
          props: {
            disabled: record.canBeModified == "3" // Column configuration not to be checked
          }
        })
      };
    },
    openDisabled() {
      // if (
      //   !this.goldOpenForm.exDat ||
      //   (!this.goldOpenForm.canBeModified &&
      //     this.goldOpenForm.canBeModified !== 0) ||
      //   this.selectedRows.length == 0 ||
      //   !this.goldOpenForm.overdueRate
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }
      if (this.selectedRows.length == 0) {
        return true;
      } else {
        return false;
      }
    },
    exDateCounts() {
      let a = this.moment(this.goldOpenForm.exDat);
      let b = this.moment(new Date());
      let res = a.diff(b, 'days');
      if (+res >= 0) {
        return res + 1;
      } else {
        return 0;
      }
    }
  },
  created() {
    this.initPage();
    this.getDicAsync("CheckMod").then(res => {
      let index = this.formConfig.findIndex(i => i.prop == "checkType");
      if (this.formConfig[index]) {
        this.formConfig[index].option = res || [];
      }
    });
    this.getparamValues()
    // 祺信开立tab 一次获取三年的节假日
    if (this.tabType == "uncommitted") {
      let year = new Date(new Date()).getFullYear();
      Promise.all([
        this.getHolDays(year),
        this.getHolDays(year + 1),
        this.getHolDays(year + 2)
      ]).then(res => {
        this.getTableData();
      });

      this.getParamByKey();
    } else {
      this.getTableData();
    }
    this.getParams()
  },
  methods: {
    ...mapActions({
      getDicAsync: "app/getDicAsync"
    }),
    // 祺信查询记录导出
    onExport() {
      let params = {};
      params = {
        useCase: "receivable",
        canEstbGldBal: this.canEstbGldBal,
        resultCode: this.resultCode,
        orderBy: this.pagination.sortField
          ? `${this.pagination.sortField == "sellrName" ? "sellrOrgCode" : this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
          },sortFlag asc`
          : "",
        isHaveContractNo: this.isHaveContractNo,
        invoiceType: (this.searchData.invoiceType && this.searchData.invoiceType.length > 0) ? this.searchData.invoiceType.join(',') : null,
        sellrOrgCode: this.searchData.sellrOrgCode && this.searchData.sellrOrgCode.key,
        invoiceNumber: this.searchData.invoiceNumber || "",
        invoiceCode: this.searchData.invoiceCode || "",
        contractNo: this.searchData.contractNo || "",
        cyCode: this.searchData.cyCode || "",
        checkType: (this.searchData.checkType && this.searchData.checkType.length > 0) ? this.searchData.checkType.map(item => typeof item === 'object' ? item.dctVal : item).join(',') : null,
        billTimeStart: this.searchData.billTime[0] || "",
        billTimeEnd: this.searchData.billTime[1] || "",
        voucherCode: this.searchData.voucherCode || "",
      };
      queryInvoiceExport(params).then(res => {
        this.utils.fileDownload(res, `查询记录_${new Date().getTime()}.xls`);
      }).catch(e => {
        this.$message.error("导出失败");
      })
    },
    handlehistoryInfo() {
      let val = null
      if (this.selectedRows.length > 0) {
        val = 1
      } else {
        val = 0
      }

      this.$refs.historyInfo.open(val)
    },
    /*回显选中的记录*/
    handleSelectHistory(selectedRow) {
      this.introducedSource = [];
      this.tblBlId = this.utils.guid(32, 16)
      console.log("%c Line:1049 🍏 this.tblBlId111", "color:#e41a6a", this.tblBlId);
      this.$nextTick(() => {
        this.$refs.childFileUpload.initData();//重置上传附件数据
      })
      console.log("%c Line:996 🍭 selectedRow", "color:#ea7e5c", selectedRow);
      // 将选中的行数据赋值到当前页面的字段
      this.importOption = [{
        cstNm: selectedRow.rcPtyNm,
        cstOrgCode: selectedRow.rcPtyOrgCode,
        guaranteeCstId: selectedRow.rcPty
      }]
      this.importData.tenantObj = {
        cstNm: selectedRow.rcPtyNm,
        label: selectedRow.rcPtyNm,
        key: selectedRow.rcPtyOrgCode,
        cstOrgCode: selectedRow.rcPtyOrgCode,
        guaranteeCstId: selectedRow.rcPty
      }
      console.log(this.importOption, this.importData.tenantObj, 123);
      this.otherform.rcPtyName = selectedRow.rcPtyNm; // 接收方名称
      this.otherform.cstOrgCode = selectedRow.rcPtyOrgCode;     // 社会信用代码
      this.otherform.gldAmt = selectedRow.gldAmt;   // 开立金额
      this.otherform.exDay = selectedRow.exDay;   // 兑付日期
      if (selectedRow.canBeModified == '1' || selectedRow.canBeModified == '0') {
        this.otherform.canBeModified = selectedRow.canBeModified;   // 是否可变更

      }
      this.otherform.overdueRate = selectedRow.odueRate;   // 罚息利率
      this.otherform.fileList = selectedRow.fileList && selectedRow.fileList.map((it) => {
        it.fileOnlyFrontDel = true //只在前端删除，不走删除接口
        return it
      });   // 附件列表
      this.introducedSource = selectedRow.fileList && selectedRow.fileList.length > 0 ? selectedRow.fileList.map((item) => {
        item.status = 'done'
        return item
      }) : [];   // 附件列表
      this.otherform.rcPty = selectedRow.rcPty;   // 附件列表
      if (this.introducedSource && this.introducedSource.length > 0) {

        this.introducedSource.forEach(item => {
          this.fileSave(item)
        })
      }

      this.otherform = { ...this.otherform };
      this.$forceUpdate()
    },
    fileSave(data) {
      const param = {
        fileNm: data.fileNm,
        fileSize: data.fileSize,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.tblBlId,
        mdlId: "10068",
        fileTpCd: "5",
        fileSubTpCd: 0
      };
      fileSaveAPI(param)
        .then(res => {
          this.introducedSource.forEach(item => {
            console.log("%c Line:1090 🍔 item.fileNm == data.fileNm", "color:#42b983", item.fileNm == data.fileNm);
            if (item.fileNm == data.fileNm) {

              this.$set(item, 'id', res.data.id)
              this.$set(item, 'fileId', res.data.fileId)
            }
          })
          // if(this.introducedSource.findIndex(it=> it.fileNm == data.fileNm) > -1 ) {
          // console.log("%c Line:1089 🍔 res", "color:#4fff4B",data.fileNm, res);

          // }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //排序
    updateSort(data) {
      updateVoucherSort({ list: data }).then(res => {
        //获取列表接口刷新
      })
    },
    handleSort(data, text) {
      let sort = null
      let sort1 = null
      let id = null
      if (text == 'up') {
        // if (data.index <= 0) {
        //     return sort = data.index
        // } else if (data.index > 0) {
        sort = data.index + 1
        if (sort >= this.otherdata.length) {
          return
        }
        this.otherdata.forEach((el, i) => {
          if (el.id == this.otherdata[data.index].id) {
            sort1 = data.index
            id = el.id
          }
        })
        // }
      } else {
        // if (data.index > this.otherdata.length - 1) {
        //     return sort = data.index
        // } else {
        sort = data.index - 1
        if (sort < 0) {
          return
        }
        this.otherdata.forEach((el, i) => {
          if (el.id == this.otherdata[data.index].id) {
            sort1 = data.index
            id = el.id
          }
        })
        // }
      }
      let params = [
        { id: data.id, sort: sort },
        { id: id, sort: sort1 }
      ]
      console.log(params);

      this.updateSort(JSON.stringify(params))
    },
    // 过滤搜索表单、表格表头展示
    initPage() {
      if (this.columnsSource) {
        let resColumn = [];
        this.columnsSource.forEach(item => {
          for (let i = 0; i < this.columns.length; i++) {
            if (this.columns[i].title == item) {
              resColumn.push({
                ...this.columns[i],
                title: this.columns[i].title2 || this.columns[i].title //针对不用的操作列表，title为区分字段，title2为显示字段
              });
              break;
            }
          }
        });
        this.columns = resColumn;
      }
      if (this.formSource) {
        let resForm = [];
        this.formSource.forEach(item => {
          for (let i = 0; i < this.formConfig.length; i++) {
            if (this.formConfig[i].prop == item) {
              resForm.push(this.formConfig[i]);
              break;
            }
          }
        });
        this.formConfig = resForm;
      }
    },
    // 卖方名称选项
    handleSearch(value, data) {
      selectSellerCst({
        pageSize: 10,
        effStCd: 1,
        statusCode: 0,
        state: 2,
        userName: value || "",
        pageNum: 1
      })
        .then(res => {
          this.formConfig.forEach((item, index) => {
            if (item.label == "卖方名称") {
              this.formConfig[index].option = res.data.grid.list;
              this.importOption = res.data.grid.list;
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 键入搜索
    handleSearchType(value, data) {
      selectSellerCstByName({ userName: value })
        .then(res => {
          this.formConfig.forEach((item, index) => {
            if (item.label == "卖方名称") {
              this.formConfig[index].option = res.data.grid.list;
              this.importTypeOption = res.data.grid.list;
            }
          });
        })
        .catch(err => {

        });
    },
    // 导入弹窗选择卖方名称
    handleSearchImport(value, data) {
      circleQuery({
        cstNm: value,
        tab: 2,
        pageSize: 10,
        pageNum: 1
      })
        .then(res => {
          this.formConfig.forEach((item, index) => {
            if (item.label == "卖方名称") {
              this.formConfig[index].option = res.data.grid.list;
              this.importOption = res.data.grid.list;
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 查询重置
    search(data, cfg) {
      console.log(data)
      this.searchData = data || this.searchData;
      this.getTableData();
    },
    //表格排序回调
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.pagination.sortField = sorter.field || pagination.sortField;
      this.pagination.sortOrder = sorter.order || pagination.sortOrder;
      this.pagination.total = this.pagination.total || 0;
      this.getTableData();
    },
    handleShowInput(record) {
      record.isInput = false
    },
    handleInputBlur(record) {
      record.payableAmount = record.payableAmountInput
      record.gldAmt = record.payableAmountInput
      record.isInput = true
    },
    getTableData() {
      let params = {};
      params = {
        useCase: "receivable",
        canEstbGldBal: this.canEstbGldBal,
        resultCode: this.resultCode,
        orderBy: this.pagination.sortField
          ? `${this.pagination.sortField == "sellrName" ? "sellrOrgCode" : this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
          },sortFlag asc`
          : "",
        isHaveContractNo: this.isHaveContractNo,
        invoiceType: (this.searchData.invoiceType && this.searchData.invoiceType.length > 0) ? this.searchData.invoiceType.join(',') : null,
        sellrOrgCode: this.searchData.sellrOrgCode && this.searchData.sellrOrgCode.key,
        invoiceNumber: this.searchData.invoiceNumber || "",
        invoiceCode: this.searchData.invoiceCode || "",
        contractNo: this.searchData.contractNo || "",
        cyCode: this.searchData.cyCode || "",
        checkType: (this.searchData.checkType && this.searchData.checkType.length > 0) ? this.searchData.checkType.map(item => typeof item === 'object' ? item.dctVal : item).join(',') : null,
        billTimeStart: this.searchData.billTime[0] || "",
        billTimeEnd: this.searchData.billTime[1] || "",
        voucherCode: this.searchData.voucherCode || "",
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      };

      this.loading = true;
      invoiceList(params)
        .then(res => {
          this.pagination.total = res.data.grid.total;
          this.tableData = res.data.grid.list.map(item => {
            item.payableAmountInput = item.payableAmount;
            item.isInput = true
            return item;
          });
          // 祺信开立需要初始化开立祺信金额
          if (this.tabType == "uncommitted") {
            this.renderTableGldAmt();
          }
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },

    // 计算表格勾选合计
    totalPayable(list, key = "invoiceAmountWithVat") {
      if (this.tabType == "uncommitted") {
        // 祺信开立页面
        key = "gldAmt";
      }
      return list.reduce((acc, rec) => {
        return acc + (+rec[key] || 0);
      }, 0);
    },
    // 查看发票
    toInvoiceInfo(record) {
      this.curRow = record;
      this.$refs.invoiceInfo.open();
    },
    // 编辑发票
    toInvoiceEdit(record) {
      this.curRow = record;
      this.$refs.invoiceEdit.open();
    },
    // 撤销
    cancel(text) {
      let billItem = this.selectedRows.find(
        i => i.payableAmount != i.canEstbGldBal
      );
      if (billItem) {
        this.$message.warn("勾选记录中存在已开立祺信的记录");
        return;
      }
      let self = this;
      this.$confirm({
        title: "撤销",
        content: "是否" + text + "所勾选的应付账款？",
        onOk() {
          const params = {
            ids: self.selectedRowKeys.join(",")
          };
          invDelete(params).then(res => {
            self.$message.success(text + "成功");
            self.selectedRowKeys = [];
            self.selectedRows = [];
            self.search();
          });
        },
        onCancel() { }
      });
    },
    // 打开导入弹窗
    onImport() {
      this.modalShowImport = true;
    },
    // 关闭导入弹窗
    closeImport() {
      this.modalShowImport = false;
      this.importData.importType = "1";
      this.importData.tenantNode = null;
      this.importData.tenantObj = {};
      this.importData.tenantName2 = undefined;
    },
    // 卖方选项变化
    changeTenant(data, node) {
      console.log(data, node);

      this.importData.tenantNode = node;
      if (this.otherOpen == true) {
        this.otherform.rcPtyName = node.cstNm
        this.otherform.cstOrgCode = node.cstOrgCode
        this.otherform.rcPty = node.guaranteeCstId
      }
    },
    // 键入卖方选项变化
    changeTenantJR(data, node) {
      console.log(node, 123);

      this.importData2.tenantNode = node;
      if (this.otherOpen == true) {
        this.otherform.tenantName2 = node.userName
        this.otherform.OrgCode = node.orgCode
        this.otherform.rcPty = node.guaranteeCstId
      }
    },
    // 校验导入弹窗条件
    checkSeller() {
      if (this.importData.importType == "1") {
        if (
          !this.importData.tenantNode ||
          (this.importData.tenantNode && !this.importData.tenantNode.cstNm)
        ) {
          this.$message.error("请填写卖方名称");
          return;
        }
        this.importOk();
      }
      if (this.importData.importType == "2") {
        console.log("%c Line:1375 🍊 this.importData", "color:#3f7cff", this.importData);
        console.log("%c Line:1375 🍊 this.importData", "color:#3f7cff", this.importData);
        if (
          !this.importData.tenantNode ||
          (this.importData.tenantNode && !this.importData.tenantNode.userName)
        ) {
          this.$message.error("请填写卖方名称");
          return;
        }
        this.importOk();
        // if (!this.importData.tenantName2) {
        //   this.$message.error("请填写卖方名称");
        //   return;
        // }
        // this.importDialogLoad = true;
        // selectSellerCstByName({ userName: this.importData.tenantName2 })
        //   .then(res => {
        //     let list = res.data.grid.list || [];
        //     if (list[0]) {
        //       this.importData.tenantNode = {
        //         cstNm: list[0].userName,
        //         cstOrgCode: list[0].orgCode,
        //         tenantId: list[0].tenantId
        //       };
        //       this.importDialogLoad = false;
        //       this.importOk();
        //     }
        //   })
        //   .catch(err => {
        //     console.log(err);
        //     this.importDialogLoad = false;
        //     this.importErrText = err.description;
        //   });
      }
    },
    // 去导入
    importOk() {
      let strName = this.importData.tenantNode && this.importData.tenantNode.cstNm
      let tenanId = this.importData.tenantNode && this.importData.tenantNode.tenantId
      let sellrOrgCode = this.importData.tenantNode && this.importData.tenantNode.cstOrgCode
      if (this.importData.importType == 2) {
        strName = this.importData.tenantNode && this.importData.tenantNode.userName
        tenanId = this.importData.tenantNode && this.importData.tenantNode.tenanId
        sellrOrgCode = this.importData.tenantNode && this.importData.tenantNode.orgCode
      }
      this.MENUAPI.goToOneTab({
        path: "bill-manage/payable-import",
        query: {
          tenanId: tenanId,


          sellrName:
            strName,
          sellrOrgCode:
            sellrOrgCode
        },
        noMenu: true
      });
      this.closeImport();
    },
    selfCheck() {
      let self = this;
      this.$confirm({
        title: "自助查验",
        content: "是否发起自助查验？",
        onOk() {
          let params = {
            cyCodeList: self.selectedRows.map(i => i.cyCode)
          };
          go2Check(params, "loading").then(res => {
            self.$message.success("操作成功");
            self.refresh();
          });
        },
        onCancel() { }
      });
    },
    systemCheck() {
      let self = this;
      this.$confirm({
        title: "平台查验",
        content: "是否发起平台查验？",
        onOk() {
          let params = {
            cyCodeList: self.selectedRows.map(i => i.cyCode)
          };
          go2PlatFormCheck(params, "loading").then(res => {
            self.$message.success("操作成功");
            self.refresh();
          });
        },
        onCancel() { }
      });
    },
    // 匹配合同
    addContract() {
      let item = this.selectedRows[0] || {};
      let diffItem = this.selectedRows.find(i => i.sellrName != item.sellrName);
      if (diffItem) {
        this.$message.warn("勾选记录的卖方名称需一致");
        return;
      }
      let contractItem = this.selectedRows.find(i => i.contractNo);
      if (contractItem) {
        this.$message.warn("勾选记录中存在已匹配合同的记录");
        return;
      }
      this.$refs.contractEdit.open();
    },
    // 匹配合同成功回调
    contractSuccessHandle() {
      this.refresh();
    },
    // 解除匹配
    delContract() {
      let contractItem = this.selectedRows.find(i => !i.contractNo);
      if (contractItem) {
        this.$message.warn("勾选记录中存在未匹配合同的记录");
        return;
      }
      let billItem = this.selectedRows.find(
        i => i.payableAmount != i.canEstbGldBal
      );
      if (billItem) {
        this.$message.warn("勾选记录中存在已开立祺信的记录");
        return;
      }
      let contractNo = this.selectedRows[0].contractNo;
      let contractNoFlag = this.selectedRows.find(
        i => i.contractNo != contractNo
      );
      if (contractNoFlag) {
        this.$message.warn("勾选记录合同编号不一致");
        return;
      }

      let self = this;
      this.$confirm({
        title: "解除匹配",
        content: "是否解除所勾选记录的合同匹配？",
        onOk() {
          let params = {
            orgCode: self.selectedRows[0].sellrOrgCode,
            ids: self.selectedRows.map(i => i.id),
            contractNo: self.selectedRows[0].contractNo
          };
          deleteContractInfo(params, "loading").then(res => {
            self.$message.success("解除成功");
            self.refresh();
          });
        },
        onCancel() { }
      });
    },
    // 编辑成功回调
    successHandle() {
      this.refresh();
    },
    // 祺信开立
    onOpen() {
      if (this.nextInvoice) {
        this.$message.warning('开立失败，平台账户未开通，请联系运营人员');
        return
      }
      this.handleSearchImport(this.selectedRows[0].sellrName)
      this.title = "祺信开立";

      this.otherform.estbName = this.userObj.cstNm
      // this.importOption = [{
      //   cstNm: this.otherform.rcPtyName,
      //   cstOrgCode: this.otherform.cstOrgCode,
      //   guaranteeCstId: ''
      // }]
      this.$nextTick(() => {
        setTimeout(() => {
          console.log(this.importOption, 123);
          if (this.importOption && this.importOption.length > 0) {
            this.otherform.rcPtyName = this.importOption[0].cstNm
            this.otherform.cstOrgCode = this.importOption[0].cstOrgCode
            this.otherform.rcPty = this.importOption[0].guaranteeCstId
            this.importData.tenantObj = {
              cstNm: this.importOption[0].cstNm,
              label: this.importOption[0].cstNm,
              key: this.importOption[0].cstOrgCode,
              cstOrgCode: this.importOption[0].cstOrgCode,
              guaranteeCstId: this.importOption[0].guaranteeCstId
            }
          }
          this.otherform.gldAmt = this.selectedRows[0].gldAmt
          this.otherform.exDay = null
          this.otherform.canBeModified = null
          this.otherform.overdueRate = null
          this.otherOpen = true;
        }, 500);
      })

      // this.$refs.goldOpenForm.validate(valid => {
      //   if (valid) {
      //     let errItem = this.selectedRows.find(
      //       item => !item.gldAmtCheck || item.gldAmt == 0
      //     );
      //     let noContractItem = this.selectedRows.find(item => !item.contractNo);
      //     let goldItem = this.selectedRows.find(
      //       i => i.payableAmount != i.canEstbGldBal
      //     );
      //     let voucherItem = this.selectedRows.find(i => i.voucherCodes);
      //     let noVoucherItem = this.selectedRows.find(i => !i.voucherCodes);
      //     if (errItem) {
      //       this.$error({
      //         title: "提示",
      //         content: `单据（编号：${errItem.invoiceNumber}）开立金额填写错误，请检查`,
      //         okText: "关闭",
      //         maskClosable: true
      //       });
      //       return;
      //     }
      //     if (noContractItem) {
      //       this.$error({
      //         title: "提示",
      //         content: `单据（编号：${noContractItem.invoiceNumber}）未匹配合同，请检查`,
      //         okText: "关闭",
      //         maskClosable: true
      //       });
      //       return;
      //     }
      //     if (noVoucherItem && voucherItem) {
      //       this.$error({
      //         title: "提示",
      //         content: `所勾选记录不可部分含有相关凭证`,
      //         okText: "关闭",
      //         maskClosable: true
      //       });
      //       return;
      //     }
      //     // if (goldItem && voucherItem) {
      //     //   this.$error({
      //     //     title: "提示",
      //     //     content: `单据（编号：${voucherItem.invoiceNumber}）含相关凭证，且已关联祺信，不可重复提交`,
      //     //     okText: "关闭",
      //     //     maskClosable: true
      //     //   });
      //     //   return;
      //     // }
      //     let params = {
      //       selected: JSON.stringify(this.selectedRows),
      //       exDat: this.goldOpenForm.exDat,
      //       tenantId: this.$store.getters["home/getTenant"].tenantId,
      //       canBeModified: this.goldOpenForm.canBeModified,
      //       overdueRate: this.goldOpenForm.overdueRate
      //     };
      //     applyGoldApi(params, true)
      //       .then(res => {
      //         this.confirmTableData = res.data.data;
      //         this.$refs.modalGoldOpen.open();
      //       })
      //       .catch(error => {
      //         console.log(error);
      //       });
      //   }
      // });
    },

    //其他开立
    disabledDate1(cuurent) {
      // Can not select days before today and today
      // return current && current < moment().endOf('day');
      // 节假日
      let data_value = this.utils.getDate(cuurent, "YYYY-mm-dd");
      const year = new Date(cuurent).getFullYear();
      if (this.isHolOrRest(year, data_value)) {
        return true;
      }

      // 小于t+10
      let today = undefined;
      let curDay = new Date(cuurent).getTime();

      // 此处为处理日期插件问题，无实际意义-开始
      if (this.otherform.exDay) {
        today = new Date(this.utils.addDate(new Date(), this.paramValue)).getTime();
      } else {
        today = new Date(this.utils.addDate(new Date(), this.paramValue)).getTime();
      }
      // 此处为处理日期插件问题-结束
      return today > curDay;
    },
    onOtherOpen() {
      if (this.nextInvoice) {
        this.$message.warning('开立失败，平台账户未开通，请联系运营人员');
        return
      }
      this.title = "其他开立";
      this.otherOpen = true;
      this.otherform = {}
      this.importData.tenantObj = {}
      this.importData2.tenantObj = {}
      this.isLRP1 = false
      this.isOthercheck = false
      this.importData.importType == 1
      this.otherform.estbName = this.userObj.cstNm
      this.importErrText = ''
      if (this.$refs.childFileUpload) {
        this.$refs.childFileUpload.initData();//重置上传附件数据
      }
      this.tblBlId = this.utils.guid(32, 16)
      console.log("%c Line:1687 🍉 this.tblBlId", "color:#f5ce50", this.tblBlId);
    },
    onOtherOpenlists() {
      if (this.nextInvoice) {
        this.$message.warning('开立失败，平台账户未开通，请联系运营人员');
        return
      }
      this.$refs.batchInvoicingDialog.open()
    },
    hadleRadio(type) {
      if (type == 1) {
        // this.otherform.tenantName2 = null
        this.otherform.OrgCode = null
        this.importData2.tenantObj = {}
      }
      if (type == 2) {
        this.importData.tenantObj = {}
        this.otherform.cstOrgCode = null
      }
    },
    handleBlur(value, data) {
      this.importErrText = ''
      // if (this.importData.importType == 2 ) {
      //   selectSellerCstByName({ userName: this.otherform.tenantName2 })
      //     .then(res => {
      //       let list = res.data.grid.list || [];
      //       if (list[0]) {
      //         this.$set(this.otherform, 'OrgCode', list[0].orgCode)
      //         this.otherform.OrgCode = list[0].orgCode
      //         this.otherform.tenantName2 = list[0].userName
      //         this.otherform.rcPty = list[0].guaranteeCstId
      //         this.importErrText = ''
      //       }
      //     })
      //     .catch(err => {
      //       console.log(err);
      //       this.importErrText = err.description;
      //       this.otherform.OrgCode = ''
      //     });
      // }
      selectSellerCstByName({
        userName: value,
        // tab: 2,
        pageSize: 10,
        pageNum: 1
      })
        .then(res => {
          this.formConfig.forEach((item, index) => {
            if (item.label == "卖方名称") {
              this.formConfig[index].option = res.data.grid.list;
              this.importOption = res.data.grid.list;
            }
          });
        })
        .catch(error => {
          console.log(error);
          this.importErrText = error.description;
          this.otherform.OrgCode = ''
        });
    },
    handleOk() {
      this.loading = true
      console.log(this.otherform);
      console.log(this.otherform.estbName);
      console.log(this.otherform.gldAmt);
      console.log(this.otherform.exDay);
      console.log(this.otherform.canBeModified);
      console.log(this.importData);
      debugger
      this.$refs.rulesotherform.validate(valid => {
        if (valid) {
          if (!this.isOthercheck) {
            this.$message.warn("请勾选付款承诺函");
            this.loading = false
            return false
          }
          if (this.isOthercheck == true) {
            this.otherOpen = false;
            this.loading = false
            if (this.title == "其他开立") {
              this.otherOpenTxnpwd = true
            } else {
              this.selectedRows[0].gldAmt = this.otherform.gldAmt
              let params = {
                selected: JSON.stringify(this.selectedRows),
                exDat: this.otherform.exDay,
                tenantId: this.$store.getters["home/getTenant"].tenantId,
                ...this.otherform
              };
              applyGoldApi(params, true)
                .then(res => {
                  this.confirmTableData = res.data.data;
                  this.$refs.modalGoldOpen.open();
                  this.selectedRows = []
                  this.selectedRowKeys = []
                })
                .catch(error => {
                  console.log(error);
                  this.selectedRows = []
                  this.selectedRowKeys = []
                });
            }
          }
        } else {
          console.log('error submit!!');
          this.loading = false
          return false;
        }
      });
    },
    handleCancel(e) {
      this.otherOpenTxnpwd = false;
    },
    handleotherCancel(e) {
      this.otherOpen = false;
      this.selectedRows = []
      this.selectedRowKeys = []
      this.$refs.rulesotherform.resetFields();
    },
    handleOther() {
      this.modalLoad = true;
      let params = { tradePassword: this.txnPwd };
      this.loading = true
      verifyTradePassword(params, true)
        .then(res => {
          if (this.otherform.tenantName2) {
            this.otherform.rcPtyName = this.otherform.tenantName2
          }
          let p = {
            estbName: this.otherform.estbName,
            rcPtyName: this.otherform.rcPtyName,
            gldAmt: this.otherform.gldAmt,
            exDay: this.otherform.exDay,
            rcPty: this.otherform.rcPty,
            canBeModified: this.otherform.canBeModified,
            overdueRateVal: String(this.otherform.overdueRate),
            txnPwd: this.utils.getPasswordEncryptString(this.txnPwd),
            tblBlId: this.tblBlId,
          };
          doSaveGuaranteeV2(p)
            .then(res => {
              this.otherOpenTxnpwd = false
              this.loading = false
              this.modalLoad = false;
              this.getTableData()
              this.$store.dispatch("home/getMessageCount");
            })
            .catch(error => {
              console.log(error);
              this.modalLoad = false;
              this.loading = false;
              this.otherOpenTxnpwd = false
              this.$emit("error", error);
            });
        })
        .catch(error => {
          console.log(error);
          this.modalLoad = false;
          this.loading = false
          this.$emit("error", error);
        });
    },
    receiveFileTblBlId(tblBlId) {
      this.tblBlId = tblBlId;
      console.log("%c Line:1817 🥒 this.tblBlId55555", "color:#33a5ff", this.tblBlId);
    },
    openFile() {
      if (this.importData.importType == 2) {
        this.otherform.cstOrgCode = this.otherform.OrgCode
        this.otherform.rcPtyName = this.otherform.tenantName2
      } else if (this.importData.importType == 1) {
        this.otherform.cstOrgCode = this.importData.tenantNode.cstOrgCode
        this.otherform.rcPtyName = this.importData.tenantNode.cstNm
      }
      const { gldAmt, exDay, rcPtyName, cstOrgCode } = this.otherform;
      const params = {
        cstName: rcPtyName, gldTAmt: gldAmt, exDat: exDay, rcPtyOrgCode: cstOrgCode, tenantId: this.$store.getters["home/getTenant"].tenantId,
        overdueRateVal: String(this.otherform.overdueRate)
      };
      if (gldAmt == null || exDay == null || rcPtyName == null || cstOrgCode == null) {
        return this.$message.warn("请填写以上内容后再查看");
      }
      getLetterofCommitment(params).then(res => {
        this.artcCntnt = res.data;
        this.$refs.fileView.open();

      }).catch(err => {

      });
    },

    // 获取节假日
    getHolDays(year) {
      if (year) {
        return new Promise((resolve, reject) => {
          queryByDate({
            date: year
          })
            .then(res => {
              this.holDayMap[year] = res.data || [];
              resolve();
            })
            .catch(err => {
              reject();
            });
        });
      }
    },
    // 判断是否为休息日或者是节假日
    isHolOrRest(year, value) {
      const list = this.holDayMap[year] || [];
      const item = list.find(
        i => i.holDt == value || i.holDt == value + " 00:00:00"
      );
      if (item) {
        return {
          ...item,
          result: true
        };
      } else {
        return null;
      }
    },
    getparamValues() {
      getparamValue().then(res => {
        this.paramValue = Number(res.data.paramValue)
        // this.overdueRate = res.data.overdueRate;
      });
    },
    // onDateChange() {
    //   this.getparamValues()
    // },
    // 开立日期选择禁用项
    disabledDate(cuurent) {
      // 节假日
      let data_value = this.utils.getDate(cuurent, "YYYY-mm-dd");
      const year = new Date(cuurent).getFullYear();
      if (this.isHolOrRest(year, data_value)) {
        return true;
      }

      // 小于t+10
      let today = undefined;
      let curDay = new Date(cuurent).getTime();

      // 此处为处理日期插件问题，无实际意义-开始
      if (this.goldOpenForm.exDat) {
        today = new Date(this.utils.addDate(new Date(), this.paramValue)).getTime();
      } else {
        today = new Date(this.utils.addDate(new Date(), this.paramValue)).getTime();
      }
      // 此处为处理日期插件问题-结束
      return today > curDay;
    },
    getParamByKey() {
      getParamByKey({ paramName: "base_interest_rate_lpr" }).then(res => {
        this.LRP = res.data;
      });
    },
    // 校验罚息利率输入0.0001 ~ 1
    overdueRateCheck(rule, value, cbfn) {
      if (!this.goldOpenForm.overdueRate) {
        cbfn("请输入罚息利率");
      } else if (
        +this.goldOpenForm.overdueRate >= 0 &&
        +this.goldOpenForm.overdueRate <= 1
      ) {
        cbfn();
        return true;
      } else {
        cbfn("罚息利率为0 ~ 1 的数字");
      }
    },
    // 校验罚息利率输入0.0001 ~ 1
    overdueRateCheck1(rule, value, cbfn) {
      if (!this.otherform.overdueRate) {
        cbfn("请输入罚息利率");
      } else if (
        +this.otherform.overdueRate >= 0 &&
        +this.otherform.overdueRate <= 1
      ) {
        cbfn();
        return true;
      }
      else {
        cbfn("罚息利率为0 ~ 1 的数字");
      }
    },

    // 校验可否变更
    canBeModifiedCheck(rule, value, cbfn) {
      if (!value && +value !== 0) {
        cbfn("请选择可否变更");
      } else {
        cbfn();
      }
    },
    //表格选择回调
    onSelect(selectedRows, checked) {
      this.selectedRowKeys = [selectedRows.id];
      this.selectedRows = [selectedRows];
      // if (checked) {
      //   this.selectedRowKeys.push(selectedRows.id);
      //   this.selectedRows.push(selectedRows);
      // } else {
      //   let index = this.selectedRowKeys.indexOf(selectedRows.id);
      //   this.selectedRowKeys.splice(index, 1);
      //   this.selectedRows.splice(index, 1);
      // }
    },
    // 表格选择处理
    // onSelectAll(selected, selectedRows, changeRows) {
    //   if (selected) {
    //     for (let i = 0; i < selectedRows.length; i++) {
    //       if (this.selectedRowKeys.indexOf(selectedRows[i].id) == -1) {
    //         this.selectedRowKeys.push(selectedRows[i].id);
    //         this.selectedRows.push(selectedRows[i]);
    //       }
    //     }
    //   } else {
    //     for (let i = 0; i < changeRows.length; i++) {
    //       let index = this.selectedRowKeys.indexOf(changeRows[i].id);
    //       if (index > -1) {
    //         this.selectedRowKeys.splice(index, 1);
    //         this.selectedRows.splice(index, 1);
    //       }
    //     }
    //   }
    // },
    // 初始化表格祺信开立金额
    renderTableGldAmt() {
      this.tableData.forEach((i, idx) => {
        //多选
        // let selectIdx = this.selectedRowKeys.indexOf(i.id);
        // let gldAmt = selectIdx > -1 ? this.selectedRows[selectIdx].gldAmt : i.canEstbGldBal;
        // this.$set(this.tableData[idx], 'gldAmt', gldAmt);
        // this.$set(this.tableData[idx], 'gldAmtCheck', true);
        //单选
        const isSelected = this.selectedRowKeys.includes(i.id);
        let gldAmt = isSelected ? this.selectedRows[0].gldAmt : i.canEstbGldBal;
        this.$set(this.tableData[idx], 'gldAmt', gldAmt);
        this.$set(this.tableData[idx], 'gldAmtCheck', true);
      })
    },
    // 校验祺信开立金额
    gldAmtCheck(item) {
      item.gldAmt = this.utils.clearNoNum(item.gldAmt);
      item.gldAmtCheck = item.gldAmt <= item.canEstbGldBal;
    },
    contractInfoOpen(data) {
      this.curRow = data;
      this.$refs.contractInfo.open();
    },
    modalOk(data) {
      this.confirmModalData = this.utils.deepClone(data);
      this.modalShowPwd = true;
    },
    modalOkPwd() {
      this.modalCancel();
    },
    modalCancel(e) {
      this.$refs.modalGoldOpen && this.$refs.modalGoldOpen.close();
      this.modalShowPwd = false;
      this.confirmModalData = null;
      this.$store.dispatch("home/getMessageCount");
      this.refresh();
    },
    // 相关凭证按钮显示
    voucherCodesOper(type, record) {
      const isOpenedBill = record.payableAmount != record.canEstbGldBal; //true:开立过祺信 false:未开立过祺信
      if (type == "add") {
        return !record.voucherCodes && !isOpenedBill;
      } else if (type == "edit") {
        return record.voucherCodes && !isOpenedBill;
      } else if (type == "detail") {
        return record.voucherCodes && isOpenedBill;
      }
    },
    // 相关凭证上传、编辑、查看
    toDeliveryCreate(dialogType, record) {
      this.deliveryVoucherDialogState = false
      if (
        dialogType == "detail"
      ) {
        this.deliveryVoucherDialogState = true
      }

      let invDataList = record ? [record] : this.selectedRows;
      for (let i = 0; i < invDataList.length; i++) {
        // if (
        //   dialogType != "detail" &&
        //   invDataList[i].payableAmount != invDataList[i].canEstbGldBal
        // ) {
        //   this.$message.warn("该单据已开立祺信，无法上传相关凭证");
        //   return;
        // }

        if (invDataList.length > 1 && invDataList[0].sellrOrgCode != invDataList[i].sellrOrgCode) {
          this.$message.warn("卖家不同，无法进行批量操作");
          return;
        }

        if (invDataList.length > 1 && invDataList[i].voucherCodes) {
          this.$message.warn("勾选记录存在相关凭证，无法进行批量操作");
          return;
        }
        else if (invDataList.length == 1 && invDataList[i].voucherCodes) {
          dialogType = "edit";
        }

      }

      this.$refs.deliveryVoucherDialog.open({
        invData: record || invDataList[0],
        invDataList: invDataList,
        dialogType: dialogType
      });
    },
    // 页面刷新方法
    refresh() {
      this.importData = {
        importType: "1",
        tenantObj: {}
      };
      this.selectedRows = [];
      this.selectedRowKeys = [];
      this.goldOpenForm = {
        exDat: undefined,
        canBeModified: 0,
        overdueRate: undefined
      };
      this.isLRP = false;
      this.isLRP1 = false;
      this.search();
    },
    //获取参数
    getParams() {
      getparamkey().then(res => {
        if (res && res.data) {
          console.log(res);
          if (res.data.paramValue == 'true') {
            if (this.userObj.openAccountStatus == 0 || this.userObj.openAccountStatus == 2) {
              this.nextInvoice = true
            } else {
              this.nextInvoice = false
            }
          } else {
            this.nextInvoice = false
          }
        }
      });
    },
  },
  watch: {
    isLRP(newVal) {
      if (newVal) {
        let num = parseInt((this.LRP / 360) * 10000) / 10000;
        if (num >= 0.0001) {
          this.goldOpenForm.overdueRate = (num + 0.0001).toFixed(4);
        } else {
          this.goldOpenForm.overdueRate = 0.0001;
        }
      }
    },
    isLRP1(newVal) {
      if (newVal) {
        let num = parseInt((this.LRP / 360) * 10000) / 10000;
        if (num >= 0.0001) {
          this.otherform.overdueRate = (num + 0.0001).toFixed(4);
        } else {
          this.otherform.overdueRate = 0.0001;
        }
      }
    },
    tableData: {
      deep: true,
      handler(newVal, oldVal) {
        this.tableData.forEach((i, idx) => {
          // 监听祺信开立页面的开立金额的输入改变
          if (this.tabType == "uncommitted") {
            let selectIdx = this.selectedRowKeys.indexOf(i.id);
            if (selectIdx > -1) {
              let gldAmt = i.gldAmt || i.canEstbGldBal;
              this.$set(this.selectedRows[selectIdx], 'gldAmt', gldAmt);
              this.$set(this.selectedRows[selectIdx], 'gldAmtCheck', true);
            }
          }
        })
      }
    }
  }
};
</script>
<style scoped>
.payable-icon {
  width: 17px;
  height: 17px;
  margin-left: 4px;
  position: absolute;
  right: 0;
  top: 7px;
}

.common-question {
  color: #ccc;
  font-size: 13px;
  margin-right: 10px;
}

.text-center {
  text-align: center;
}

.item-input {
  width: 200px;
}

.item-box>label {
  min-width: 70px;
}

.item-box {
  margin: 0 15px 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/payable/list.vue